<template>
  <div class="row kanban-card-details">
    <div class="lead-time card-content" v-if="scan">
      <img src="../../assets/icons/kanban-lead-time.svg" alt="">
      <p class="card-title">Lead Time</p>
      <p>
        Dernier scan carte :<b>{{ noScanSince }}</b> J 
        <span style="margin-left: 20px;">
        Moyenne : <b>{{ (scan.average_speed / 86400).toFixed(2) }}J </b></span>
      </p>
      <p><b>{{ andonSpeed(scan.andon_speed) }}</b></p>
    </div>
    <div class="supply-info card-content">
      <img src="../../assets/icons/kanban-livraison.svg" alt="">
      <p class="card-title">Livraison</p>
      <p>Fourniseur : <b>{{ supplier }}</b></p>
      <p>Commandé le : <b>{{ lastBL.command_date  | moment('DD/MM/YYYY') }}</b></p>
      <p>Prévu pour le : <b>{{ lastBL.delivery_date | moment('DD/MM/YYYY')}}</b></p>
      <p>Quantité : <b>{{ lastBL.quantity }}</b></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KanbanCardDetails',
  props: [
    'noScanSince',
    'supplier',
    'lastBL',
    'scan',
  ],
  computed: {
  },
  methods: {
    andonSpeed (speed) {
      if (speed === 'fast') {
        return 'Acceleration'
      } else if (speed === 'slow') {
        return 'Ralentissement'
      }
      return ''
    }
  }
};
</script>

<style>
  .kanban-card-details {
    width: 100%;
    margin: 0 auto;
  }

  .card-content {
    display: flex;
    flex: 40%;
    flex-direction: column;
    justify-content: space-between;
    background-color: #4262d4;
    border-bottom: 12px solid #5d83e4;
    color: white;
    flex-grow: 1;
    border-radius: 10px;
    padding: 0.5rem 1rem;
    position: relative;
    box-shadow: 2px 2px 15px 0 rgb(152 152 152 / 60%);
  }

  .card-title {
    text-transform: uppercase;
  }

  .lead-time {
    min-width: 180px;
    margin-right: 1rem;
  }

  .card-content > img {
    position: absolute;
  }

  .card-content p b {
    margin-left: 3%;
  }

  .central-information {
    font-size: 55px;
    text-align: center;
  }

  @media screen and (orientation: portrait) {
    .card-content > img {
      top: 10px;
      right: 10px;
    }

    .card-title {
      font-size: 20px;
    }

    .lead_info {
      font-size: 20px;
    }

    .supply-info.card-content {
      font-size: 20px;
    }
  }

  @media screen and (orientation: landscape) {
    .card-content > img {
      top: 6px;
      right: 6px;
    }

    .card-title {
      font-size: 16px;
    }

    .lead_info {
      font-size: 15px;
    }

    .supply-info.card-content {
      font-size: 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/kanban/KanbanCardDetails.vue